import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "This part demonstrates an audiovisual illusion, the McGurk effect. Please play the video below. If you focus on the left speaker, you will hear the series of morphemes “ba ba ba”. If you focus on the right speaker, you might here something different, even though the sound does not change.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 5],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Audiovisual illusion",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "video",
                options: {
                  src: `${config.ASSETS_URL}/02/30/principle/slide-1.mp4`,
                },
              },
              styles: {
                padding: "1% 9%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
